import { SidePanelTemplate } from '@features/ui-layout/components/SidePanel/SidePanelTemplate';
import { useTranslation } from 'next-i18next';

interface UserSidePanelProps {
  userId?: number;
  closeSidePanel: () => void;
}

export const UserSidePanel = ({ userId, closeSidePanel }: UserSidePanelProps): JSX.Element => {
  const { t } = useTranslation('common');

  return (
    <SidePanelTemplate title={t('sidePanels.user.title')} closeSidePanel={closeSidePanel}>
      <p>{t('sidePanels.user.description', { userId })}</p>
    </SidePanelTemplate>
  );
};
